export default __webpack_public_path__ + "static/media/calendar.cec85e15.png";